import posthog from 'posthog-js';
import { RecordModel } from 'pocketbase';
import { Pilot } from './types';
import { pb } from './pocketbase';

const isProductionEnvironment = () =>
  process.env.NODE_ENV === 'production' &&
  process.env.VERCEL_ENV !== 'preview';

export const isPosthogEnabled = () =>
  typeof window !== 'undefined' &&
  isProductionEnvironment() &&
  Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY);

const getPosthogInstance = () => (isPosthogEnabled() ? posthog : null);

export const identifyPosthogUser = (
  user: RecordModel,
  pilot: Pilot | null,
) => {
  const instance = getPosthogInstance();
  if (!instance) return;

  const avatarUrl = user.avatar
    ? pb.files.getUrl(user, user.avatar as string, { thumb: '120x120' })
    : undefined;

  instance.identify(user.id, {
    email: user.email,
    name: pilot?.nome || user.name || user.email,
    avatar: avatarUrl,
    pilot_id: pilot?.id,
    pilot_name: pilot?.nome,
    pilot_category: pilot?.categoria,
    user_agent: navigator.userAgent,
  });
};

export const capturePosthogEvent = (
  eventName: string,
  properties?: Record<string, unknown>,
) => {
  const instance = getPosthogInstance();
  if (!instance) return;

  instance.capture(eventName, {
    user_agent: navigator.userAgent,
    ...properties,
  });
};

export const resetPosthogUser = () => {
  const instance = getPosthogInstance();
  if (!instance) return;

  instance.reset();
};
